<template>
	<div id="render3d" ref="renderdiv">


		
	</div>
</template>

<script>


import * as THREE from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';

import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"

export default {
	name: 'Scene3D',
	props: {
		
	},
	data : function() {
		return {

			scene: null,
			camera: null,
			renderer: null,

			controls: null,

			textureLoader: null,
			loadingManager: null,
			RGBELoader: null,
			FBXLoader: null,

			pmremGenerator : null,
			exrCubeRenderTarget: null,
			envMap: null,
			hdrCubeMap: null,

			productGroup: new THREE.Group()

		}
	},
	mounted() {

		this.init();
		this.resize();
		this.animate();
		
	},
	created() {

		window.addEventListener('resize', () => {this.resize()})
		
	},
	methods : {

		//UNITY START
		init() {

			this.loadingManager = new THREE.LoadingManager();
			this.RGBELoader = new RGBELoader(this.loadingManager);
			this.FBXLoader = new FBXLoader(this.loadingManager);
			this.textureLoader = new THREE.TextureLoader(this.loadingManager);


			this.scene = new THREE.Scene()

			this.camera = new THREE.PerspectiveCamera(35, window.innerWidth / window.innerHeight, 1.0, 8000);

			this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });

			this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
			this.renderer.toneMappingExposure = 1.3;
			this.renderer.outputEncoding = THREE.sRGBEncoding;

			this.renderer.setPixelRatio( window.devicePixelRatio );
			this.renderer.setSize( window.innerWidth, window.innerHeight );

			this.renderer.physicallyCorrectLights = true;
			this.renderer.gammaFactor = 2.2;
			this.renderer.setClearAlpha(0.0);
			this.renderer.setClearColor( 0xffffff, 0.0);
			this.renderer.autoClear = true;


			this.controls = new OrbitControls( this.camera, this.renderer.domElement );
			this.controls.enableDamping = true; 
			this.controls.minDistance = 650;
			this.controls.maxDistance = 1000;
			this.controls.target = new THREE.Vector3(0,80.0,0);

			this.camera.position.x = 250;
			this.camera.position.y = 250;
			this.camera.position.z = -700;



			this.scene.add(this.productGroup)


			// envMap
			this.pmremGenerator = new THREE.PMREMGenerator( this.renderer );
			this.pmremGenerator.compileEquirectangularShader();
			this.loadingManager.onLoad = () => {
				this.pmremGenerator.dispose();
			}
			this.loadEnvMap();



			this.$refs.renderdiv.appendChild(this.renderer.domElement)


			this.createTracteur();
		},

		loadEnvMap() {
			this.RGBELoader.setPath( 'data/textures/env/' ).setDataType( THREE.UnsignedByteType ).load('quattro_canti_1k.hdr', (texture) => {
				texture.magFilter = THREE.LinearFilter;
				texture.needsUpdate = true;

				
				this.envMap = this.pmremGenerator.fromEquirectangular( texture ).texture;
				this.envMap.encoding = THREE.RGBEEncoding;
				//this.scene.background = this.envMap;
				this.scene.environment = this.envMap;



				// Generate cubemap object for custom shader uniforms
				// -------------------------------------------------
				var options = {
					generateMipmaps: true,
					minFilter: THREE.LinearMipMapLinearFilter,
					magFilter: THREE.LinearFilter
				};

				var newTexHDR = texture.clone();
				texture.encoding = THREE.RGBEEncoding;
				newTexHDR.minFilter = THREE.NearestFilter;
				newTexHDR.magFilter = THREE.NearestFilter;
				newTexHDR.flipY = true;
				this.hdrCubeMap = new THREE.WebGLCubeRenderTarget( 32, options ).fromEquirectangularTexture( this.renderer, newTexHDR ).texture;
				this.hdrCubeMap.encoding = THREE.RGBEEncoding;
				this.hdrCubeMap.mapping = THREE.EquirectangularReflectionMapping;
				this.hdrCubeMap.needsUpdate = true;
	
				// -------------------------------------------------

				texture.dispose();
				this.pmremGenerator.dispose();


			});	
		},




		createTracteur() {

			var cabine_ALB = this.textureLoader.load('data/products/v70/cabine_ALB.jpg')
			cabine_ALB.encoding = THREE.sRGBEncoding;
			var cabine_ARM = this.textureLoader.load('data/products/v70/cabine_ARM.jpg')
			var cabine_N = this.textureLoader.load('data/products/v70/cabine_N.png')
			var cabine_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: cabine_ALB,
				aoMap: cabine_ARM,
				roughnessMap: cabine_ARM,
				metalnessMap: cabine_ARM,
				normalMap: cabine_N,
				side: THREE.DoubleSide
			})

			var equipement_ALB = this.textureLoader.load('data/products/v70/equipement_ALB.jpg')
			equipement_ALB.encoding = THREE.sRGBEncoding;
			var equipement_ARM = this.textureLoader.load('data/products/v70/equipement_ARM.jpg')
			var equipement_N = this.textureLoader.load('data/products/v70/equipement_N.png')
			var equipement_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: equipement_ALB,
				aoMap: equipement_ARM,
				roughnessMap: equipement_ARM,
				metalnessMap: equipement_ARM,
				normalMap: equipement_N
			})

			var essieux_ALB = this.textureLoader.load('data/products/v70/essieux_ALB.jpg')
			essieux_ALB.encoding = THREE.sRGBEncoding;
			var essieux_ARM = this.textureLoader.load('data/products/v70/essieux_ARM.jpg')
			var essieux_N = this.textureLoader.load('data/products/v70/essieux_N.png')
			var essieux_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: essieux_ALB,
				aoMap: essieux_ARM,
				roughnessMap: essieux_ARM,
				metalnessMap: essieux_ARM,
				normalMap: essieux_N
			})

			var gardeboue_ALB = this.textureLoader.load('data/products/v70/gardeboue_ALB.jpg')
			gardeboue_ALB.encoding = THREE.sRGBEncoding;
			var gardeboue_ARM = this.textureLoader.load('data/products/v70/gardeboue_ARM.jpg')
			var gardeboue_N = this.textureLoader.load('data/products/v70/gardeboue_N.png')
			var gardeboue_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: gardeboue_ALB,
				aoMap: gardeboue_ARM,
				roughnessMap: gardeboue_ARM,
				metalnessMap: gardeboue_ARM,
				normalMap: gardeboue_N
			})

			var interieur_ALB = this.textureLoader.load('data/products/v70/interieur_ALB.jpg')
			interieur_ALB.encoding = THREE.sRGBEncoding;
			var interieur_ARM = this.textureLoader.load('data/products/v70/interieur_ARM.jpg')
			var interieur_N = this.textureLoader.load('data/products/v70/interieur_N.png')
			var interieur_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: interieur_ALB,
				aoMap: interieur_ARM,
				roughnessMap: interieur_ARM,
				metalnessMap: interieur_ARM,
				normalMap: interieur_N
			})

			var marches_ALB = this.textureLoader.load('data/products/v70/marches_ALB.jpg')
			marches_ALB.encoding = THREE.sRGBEncoding;
			var marches_ARM = this.textureLoader.load('data/products/v70/marches_ARM.jpg')
			var marches_N = this.textureLoader.load('data/products/v70/marches_N.png')
			var marches_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: marches_ALB,
				aoMap: marches_ARM,
				roughnessMap: marches_ARM,
				metalnessMap: marches_ARM,
				normalMap: marches_N
				
			})

			var moduleav_ALB = this.textureLoader.load('data/products/v70/moduleav_ALB.jpg')
			moduleav_ALB.encoding = THREE.sRGBEncoding;
			var moduleav_ARM = this.textureLoader.load('data/products/v70/moduleav_ARM.jpg')
			var moduleav_N = this.textureLoader.load('data/products/v70/moduleav_N.png')
			var moduleav_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: moduleav_ALB,
				aoMap: moduleav_ARM,
				roughnessMap: moduleav_ARM,
				metalnessMap: moduleav_ARM,
				normalMap: moduleav_N
			})

			var parechocav_ALB = this.textureLoader.load('data/products/v70/parechocav_ALB.jpg')
			parechocav_ALB.encoding = THREE.sRGBEncoding;
			var parechocav_ARM = this.textureLoader.load('data/products/v70/parechocav_ARM.jpg')
			var parechocav_N = this.textureLoader.load('data/products/v70/parechocav_N.png')
			var parechocav_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: parechocav_ALB,
				aoMap: parechocav_ARM,
				roughnessMap: parechocav_ARM,
				metalnessMap: parechocav_ARM,
				normalMap: parechocav_N,
				side: THREE.DoubleSide
			})

			var tubes_ALB = this.textureLoader.load('data/products/v70/tubes_ALB.jpg')
			tubes_ALB.encoding = THREE.sRGBEncoding;
			var tubes_ARM = this.textureLoader.load('data/products/v70/tubes_ARM.jpg')
			var tubes_N = this.textureLoader.load('data/products/v70/tubes_N.png')
			var tubes_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: tubes_ALB,
				aoMap: tubes_ARM,
				roughnessMap: tubes_ARM,
				metalnessMap: tubes_ARM,
				normalMap: tubes_N
			})

			var wheels_ALB = this.textureLoader.load('data/products/v70/wheels_ALB.jpg')
			wheels_ALB.encoding = THREE.sRGBEncoding;
			var wheels_ARM = this.textureLoader.load('data/products/v70/wheels_ARM.jpg')
			var wheels_N = this.textureLoader.load('data/products/v70/wheels_N.png')
			var wheels_mat = new THREE.MeshStandardMaterial({
				roughness: 1.0,
				metalness: 1.0,
				color: 0xffffff,
				map: wheels_ALB,
				aoMap: wheels_ARM,
				roughnessMap: wheels_ARM,
				metalnessMap: wheels_ARM,
				normalMap: wheels_N
			})

			var socle_map = this.textureLoader.load('data/products/v70/socle.jpg')
			socle_map.encoding = THREE.sRGBEncoding;
			var socle_mat = new THREE.MeshStandardMaterial({

				color: 0xffffff,
				map: socle_map,
				aoMap: socle_map,
				roughness: 0.666,
				metalness: 0.0

			})

			this.FBXLoader.load('data/products/v70/tracteur.fbx', (object) => {
				var mesh = object.children[0];

				console.log('tracteur', mesh)

				mesh.material = [
					essieux_mat,
					interieur_mat,
					gardeboue_mat,
					marches_mat,
					equipement_mat,
					wheels_mat,
					socle_mat,
					tubes_mat,
					parechocav_mat,
					moduleav_mat,
					cabine_mat
			
				]
				this.productGroup.add(mesh)
			})

			this.FBXLoader.load('data/products/v70/tracteur_vitres.fbx', (object) => {
				var mesh = object.children[0];

				console.log('vitre', mesh)

				mesh.material = new THREE.MeshPhysicalMaterial( {
					roughness: 0.0,
					metalness: 0.2,
					transparent: true,
					opacity: 1.0,
					transmission:0.8,
					color: 0x09232c,
					side: THREE.DoubleSide
				})
				this.productGroup.add(mesh)
			})



		},

		resize() {

			var width = window.innerWidth;
			var height = window.innerHeight;


			this.camera.aspect = width / height;
			this.camera.updateProjectionMatrix();

			this.renderer.setSize( width, height );

		},

		//UNITY UPDATE
		animate() {
			requestAnimationFrame( this.animate );

			// code animation
			//this.productGroup.rotation.y += 0.0025

			this.render();
		},

		render() {
			this.controls.update();
			this.renderer.render( this.scene, this.camera );
		}

	}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
